<div class="tab-content">
  <form nz-form [formGroup]="modelsSearchForm">
    <div nz-row [nzGutter]="8" [nzAlign]="'middle'">
      <div nz-col *ngIf="modelsChecked.length > 0">
        <button nz-button nzType="default" nzSize="large" nz-dropdown [nzDropdownMenu]="modelsActionMenu" [disabled]="modelsActionIsLoading">
          <i *ngIf="modelsActionIsLoading" nz-icon nzType="loading" class="loading-icon"></i>
          {{ modelsChecked.length }} {{ modelsChecked.length > 1 ? 'modèles séléctionnés' : 'modèle séléctionné' }}
          <i nz-icon nzType="down"></i>
        </button>
        <nz-dropdown-menu #modelsActionMenu="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            <li nz-menu-item nzDanger (click)="deleteCheckedVehicleModel()">
              <i nz-icon nzType="delete"></i>
              Désactiver
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="modelsChecked.splice(0, modelsChecked.length)">
              <i nz-icon nzType="minus-square"></i>
              Tout déséléctionner
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
      <div nz-col nzFlex="1 1 auto">
        <nz-input-group [nzPrefix]="prefixIconSearch" nzSize="large">
          <ng-template #prefixIconSearch>
            <i nz-icon nzType="search"></i>
          </ng-template>
          <input type="text" nz-input placeholder="Rechercher un modèle de véhicule" formControlName="search" />
        </nz-input-group>
      </div>
      <div nz-col>
        <button type="button" nz-button nzType="primary" nzSize="large" (click)="addVehicleModel()">
          <i nz-icon nzType="plus"></i>
          Ajouter un modèle
        </button>
      </div>
    </div>
  </form>
  <nz-table
    nzShowSizeChanger
    [nzData]="modelsData ? modelsData.data : []"
    [nzFrontPagination]="false"
    [nzLoading]="modelsIsLoading"
    [nzTotal]="modelsData ? modelsData.metadata.totalResults : 0"
    [nzPageSize]="modelsLimit"
    [nzPageIndex]="modelsData ? modelsData.metadata.currentPage : 0"
    [nzNoResult]="modelsEmptyTemplate"
    (nzQueryParams)="setModelsPage($event)"
    *ngIf="!modelsError; else modelsErrorTemplate">
    <thead>
    <tr>
      <th nzWidth="60px"></th>
      <th nzColumnKey="active" nzWidth="60px" [nzSortFn]="true">Actif</th>
      <th nzColumnKey="brand" [nzSortFn]="true">Marque</th>
      <th nzColumnKey="name" [nzSortFn]="true">Modèle</th>
      <th nzColumnKey="category" [nzSortFn]="true">Catégorie</th>
      <th nzColumnKey="actions" class="actions">Actions</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let model of modelsData?.data">
      <tr>
        <td [nzChecked]="modelsChecked.includes(model.id)" (nzCheckedChange)="setModelsChecked($event, model.id)"></td>
        <td><label nz-checkbox nzDisabled [(ngModel)]="model.active"></label></td>
        <td>{{ model.brand.name }}</td>
        <td>{{ model.name }}</td>
        <td>
          <button nz-button>
            <i nz-icon [nzType]="model.category | vehicleCategoryIcon"></i>
            {{ model.category | vehicleCategoryName }}
          </button>
        </td>
        <td class="actions">
          <button nz-button class="mr-8" (click)="editVehicleModel(model)">Modifier</button>
          <button nz-button nzType="primary" (click)="deleteVehicleModel(model)" [disabled]="!model.active">
            <i nz-icon nzType="delete"></i>
          </button>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </nz-table>
  <ng-template #modelsErrorTemplate>
    <nz-result nzTitle="Erreur de chargement" nzStatus="error"
               nzSubTitle="Une erreur est survenue lors du chargement de la liste des modèles de véhicule">
      <div nz-result-extra>
        <button nz-button nzType="primary" (click)="loadModelsData()">
          Réessayer
          <i nz-icon nzType="reload"></i>
        </button>
      </div>
    </nz-result>
  </ng-template>
  <ng-template #modelsEmptyTemplate>
    <nz-empty nzNotFoundImage="simple"
              nzNotFoundContent="Aucun modèle de véhicule trouvé. Commencez par en ajouter un en utilisant le bouton ci-dessous."
              [nzNotFoundFooter]="modelsEmptyFooter">
      <ng-template #modelsEmptyFooter>
        <button nz-button nzType="primary" (click)="addVehicleModel()">
          <i nz-icon nzType="plus"></i>
          Ajouter un modèle de véhicule
        </button>
      </ng-template>
    </nz-empty>
  </ng-template>
</div>
